import { render, staticRenderFns } from "./OpenApiMain.vue?vue&type=template&id=d2a288a4&scoped=true"
import script from "./OpenApiMain.vue?vue&type=script&lang=ts"
export * from "./OpenApiMain.vue?vue&type=script&lang=ts"
import style0 from "./OpenApiMain.vue?vue&type=style&index=0&id=d2a288a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a288a4",
  null
  
)

export default component.exports